import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from "@angular/router";
import { CrudService } from "app/shared/crud-service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { AtividadeDTO } from "./atividade.model";
import { ConvidadoAtividade } from "./dtos/ConvidadoAtividade.dto";
import { AuthenticateOutlook } from "../agenda/outlook.service";

@Injectable({
  providedIn: 'root'
})
export class AtividadeService extends CrudService<AtividadeDTO> implements Resolve<any> {
    routeParams: any;

    constructor(protected http: HttpClient) {
      super(http, `${environment.baseUrl}/Atividades`);
    }    

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;                
        if (this.routeParams.id === "new") {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getById(this.routeParams.id);
        }
    }  

    updateAtividade(atividade: AtividadeDTO):  Promise<any> {        
        const id = atividade.idAtividade;            
        return new Promise((resolve,reject)=>{
            this.http
                .put(`${environment.baseUrl}/Atividades/${id}` , atividade)
                .subscribe(res=>{
                    resolve(res);
                },reject);
        });        
    }   
    deleteDiagnostico(idDiagnostico: number):  Promise<any> {        
        return new Promise((resolve,reject)=>{
            this.http
                .delete(`${environment.baseUrl}/Atividades/diagnostico/` + idDiagnostico)
                .subscribe(res=>{
                    resolve(res);
                },reject);
        });      
    }

    getByIdFromAgenda(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .get(`${environment.baseUrl}/Atividades/${id}`)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getQtdNotificacoes(vendedorId: number): Promise<any> {
            return new Promise((resolve, reject) => {
            this.http.get(`${environment.baseUrl}/Atividades/Notificacoes?vendedorId=${vendedorId}`).subscribe((response: any) => {
                resolve(response);
                }, reject);
        });      
    }

    postConvidarConsultores(convidadosAtividade: ConvidadoAtividade): Promise<any> {
        return new Promise((resolve,reject) => {
            this.http.post(`${environment.baseUrl}/ConviteAtividade`,convidadosAtividade).subscribe( res => {
                resolve(res);
            }, reject);
        });
    }

    deleteConviteConsultor(idConviteAtividade: any): Promise<any> {
        return new Promise((resolve,reject) => {
            this.http.delete(`${environment.baseUrl}/ConviteAtividade/${idConviteAtividade}`).subscribe( res => {
                resolve(res);
            },reject);
        });
    }

    putConviteAtividade(idConviteAtividade: any, aceita: string): Promise<any> {
        return new Promise((resolve,reject)=>{
            this.http.put(`${environment.baseUrl}/ConviteAtividade/${idConviteAtividade}/responder?aceitar=${aceita}`, null).subscribe( res => {
                resolve(res);
            },reject);
        });
    }

    getConvidadosByAtividade(atividadeId: number): Promise<any> {
        return new Promise((resolve,reject) => {
            this.http.get(`${environment.baseUrl}/ConviteAtividade/ByAtividade/${atividadeId}`).subscribe( res => {
                resolve(res);
            }, reject);
        });
    }

    postSendAtividadeOutlook(atividadeId: number): Promise<any> {
        return new Promise((resolve,reject) => {
            this.http.post(`${environment.apiOutlook}/processar/atividade?atividadeId=${atividadeId}`,{}).subscribe( res => {
                resolve(res);
            },reject)
        });
    }

    getVerifyAuthenticationOutlook(): Promise<AuthenticateOutlook> {
        const response = this.http.get<AuthenticateOutlook>(`${environment.apiOutlook}/verifyAuthentication`).toPromise();
        return response;
    }


} 